import React from "react";

export default function Spinner({ width, height, color = "#fa86ac" }) {
  return (
    <div className="flex justify-center items-center pt-12" >
      <div
        className="spinner-border"
        role="status"
        style={{ color: color, width: width, height: height, }}
      ></div>
    </div>
  );
};
